import { AppRoot } from './sienge-pay/app-root';

export default AppRoot;
